module.exports = __webpack_public_path__ + "static/media/the-crew.e5480736.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/the-crew.jpg
// module id = 626
// module chunks = 0